import { flexRender } from '@tanstack/react-table';

export type TableHeaderDataType = {
  headerId: any;
  colSpan: any;
  rowSpan: any;
  content: JSX.Element | React.ReactNode;
};

export default function useGeneeratePivotTableHeader() {
  const generateHeaderData = (headerGroups) => {
    return headerGroups.map((headerGroup) => {
      return headerGroup.headers.map((header) => {
        const column = header.column.columnDef;
        const item = {
          headerId: header.id,
          colSpan: header.colSpan,
          rowSpan: header.rowSpan,
          content: flexRender(column.header, header.getContext()),
        } as TableHeaderDataType;
        return item;
      });
    }) as TableHeaderDataType[][];
  };
  return generateHeaderData;
}
